<template>
  <div>
    <div class="width_div padding_bottom_350">
      <div class="title_div">
        <p class="p1">查看资讯</p>
        <p class="p2">荟集行业动态与各路情报</p>
      </div>
      <news-list pageSize="999"></news-list>
    </div>
  </div>
</template>
  <script>
import * as API from "@/api/index";
import * as navBar from "./navbar/navbar";
import NewsList from "./view/NewsList.vue";
export default {
  components: {
    NewsList,
  },
  data() {
    return {
      list: [{ img: "" }],
      imgs: [{ img: "" }],
      currentPage: 1,
      totalPage: 1,
      pageSize: 100,
      type: 1, //新闻类型
      isMiniWindows: false,
      clientWidth: 0,
    };
  },
  watch: {
    clientWidth(newVal, oldVal) {
      // console.log(newVal); //浏览器窗口变化时，打印宽度。
      if (newVal < 1200) {
        this.isMiniWindows = true;
      } else {
        this.isMiniWindows = false;
      }
    },
    $route(to, from) {
      if (to.path.indexOf("/News") != -1) {
        var param = this.$route.query.param;
        if (param) {
          console.log("News param:" + param);
          this.type = param;
        }
          window.scrollTo(0, 0);
        // this.getList();
        // this.getImg();
        // if (from.path.indexOf("NewsDetail") == -1) {
        // }
      }
    },
  },
  created() {},
  computed: {
    nav_title() {
      return navBar.getList();
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.getList();
    // this.getImg();
    let that = this;
    var clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
          document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  methods: {
    pushTo(path) {
      this.$router.push(path);
    },
  },
};
</script>
  <style lang="scss" scoped>
.title_div {
  margin-top: 29rem;
  margin-bottom: 8rem;
  p {
    text-align: start;
  }
  .p1 {
    font-size: 2.6rem;
    letter-spacing: -1px;
  }
  .p2 {
    font-size: 3.6rem;
    letter-spacing: -1px;
  }
}
@media (max-width: 1000px) {
  .title_div {
    margin-top: 11rem;
    margin-bottom: 0;
    margin-left: 2.7rem;
    p {
      text-align: start;
    }
    .p1 {
      font-size: 1.7rem;
      letter-spacing: 0;
    }
    .p2 {
      font-size: 2.5rem;
      letter-spacing: -1px;
    }
  }
  .width_div.padding_bottom_350 {
    padding-bottom: 16rem;
  }
}
</style>